/**
 * displayOrder 기준 오름차순 정렬 (원본 배열 변경 없이 새 배열 반환)
 */
export const sortByDisplayOrder = <T extends { displayOrder?: number }>(data: T[]): T[] =>
    [...data].sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));
